




























































































































































































































































































import { Component, Vue, Provide, Watch, Prop } from "vue-property-decorator";
import { localGet, timeFormat, timeFormatSecond, setMetaData } from "@/utils";
import { setCommon, errorMsg } from "@/utils/request";
import { ticketClient } from "@/api/index";
import { ListPhoneSaleProductReq } from "@/pbjs/xcommon/ticket_pb.js";
import SupplierJson from "@/doc/Supplier.json"; //  lee 自己存储的供应商json
import { Loading } from "element-ui";

@Component({
  name: "phoneSale",
})
export default class CombinationProperty extends Vue {
  @Provide() private remark: string = ""; //备注
  @Provide() private phoneTime: any = ""; //拨打时间
  @Provide() private fullLoading: any = ""; //全局loading
  @Provide() private orderid: any = 0;
  @Provide() private itemId: any = 103; // 103 表示原来，104 表示 36264需求
  @Provide() private dialid: any = 0; //拨打电话id
  @Provide() private centerDialogVisible: Boolean = false; //dialog
  @Provide() private btnType: string = "primary"; //button type
  @Provide() private btnDisable: Boolean = false; //button disabled
  @Provide() private suppliertypeList: any = [];
  @Provide() private providerOptions: any = [];
  @Provide() private dialogForm: any = {
    birthday: "",
  };
  @Provide() private selectForm: any = {
    callStatus: "",
    callResult: "",
  };
  @Provide() private phoneSaleDetail: any = {
    useraccountname: "",
    orderid: "",
    orderstatus: "",
    invalidTime: "",
    loanamount: "",
    displayrawphone: false,
  };
  @Provide() private callResultOption: any = [];
  @Provide() private country: any = "";
  @Provide() private systemInfo: any = "";
  @Provide() private supplierOptions: any[] = SupplierJson.list; // 匹配供应商映射list
  @Provide() private rules: any = {
    callStatus: [
      { required: true, message: "please select", trigger: "change" },
    ],
    callResult: [
      { required: true, message: "please select", trigger: "change" },
    ],
  };
  @Provide() private productOrderId: any = "";
  @Provide() private productList: any = [];

  private mounted() {
    this.orderid = this.$route.query.id;
    this.itemId = this.$route.query.itemId;
    this.productOrderId = this.$route.query.orderId;
    this.country = localStorage.getItem("country");
    this.systemInfo = localStorage.getItem("systemInfo"); // 获取系统信息
    this.fullLoading = Loading.service({ fullscreen: true });
    this.dialogForm.birthday = "1990-01-01";
     // caseid
    this.getCaseDetail();
    if(this.country === 'en') {
      this.getProductInfoList();
    }
  }
  private matchProviderOptions() {
    this.supplierOptions.forEach((item: any) => {
      this.suppliertypeList.forEach((s: any) => {
        if (item.id == s) {
          this.providerOptions.push(item);
        }
      });
    });

  }

  private getProductInfoList() {
    let request: any = new ListPhoneSaleProductReq();
    request.setCommonin(setCommon());
    request.setOrderid(this.productOrderId);
    ticketClient.listPhoneSaleProduct(
      request,
      setMetaData(),
      (err: any, response: any) => {
        if (response) {
          const data: any = response.toObject();
          if (data.commonout.code == 0) {
            this.productList = data.products.sectionsList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
      }
    );
  }

  //获取 电销 详情
  private async getCaseDetail() {
    const { getPhoneSaleCaseReq, getPhoneSaleCaseRequest }: any = await import(
      "@/request/phoneSale"
    );
    let arg = {
      caseid: this.orderid,
    };
    let res = await getPhoneSaleCaseRequest.handleHttp(
      getPhoneSaleCaseReq(arg),
      null
    );
    if (res && res.right) {
      this.phoneSaleDetail = res;
      this.phoneSaleDetail.invalidTime = timeFormatSecond(
        this.phoneSaleDetail.invalidtime
      );
      this.phoneSaleDetail.mobilenxsalt = this.phoneSaleDetail.phoneinfo.mobilenxsalt;
      this.fullLoading.close();
      this.suppliertypeList = res.suppliertypeList;
      this.matchProviderOptions();
    } else {
      this.fullLoading.close();
    }
  }

  // 放款/继续跟进
  private submitPhoneCase(formName: any) {
    const ref: any = this.$refs[formName];
    ref.validate((valid: boolean) => {
      if (valid) {
        this.savePhoneCase(2);
      } else {
        return false;
      }
    });
  }

  // 获取地推 非地推 label ticketWrh.IsGP1
  private getIsGPLabel(params?: number) {
    let label = "-";
    switch (params) {
      case 0:
        label = "ticketWrh.IsGP0";
        break;
      case 1:
        label = "ticketWrh.IsGP1";
        break;
      default:
        label = "-";
        break;
    }
    return label;
  }

  // 放款/继续跟进
  private submitForm(formName: any, type: any) {
    const ref: any = this.$refs[formName];
    ref.validate((valid: boolean) => {
      if (valid) {
        if (type == 2) {
          // 当为 103时 不需要验证
          this.itemId === "103"
            ? (this.centerDialogVisible = true)
            : this.savePhoneCase(2);
        } else {
          this.savePhoneCase(1);
        }
      } else {
        return false;
      }
    });
  }

  private statusChange(val: any) {
    this.selectForm.callResult = "";
    if (val == 1) {
      //电话接通
      this.btnType = "primary";
      this.btnDisable = false;
      this.callResultOption = this.phoneSaleDetail.phoneconnectedmapMap;
    } else {
      //未接通
      if (this.itemId === "103") {
        this.btnType = "info";
        this.btnDisable = true;
      }
      this.callResultOption = this.phoneSaleDetail.phoneunconnectedmapMap;
    }
  }

  private async call(supplier: any, mobile: any) {
    let _arg = {
      assignuId: Number(localGet("userid")),
      phoneNumber: mobile + "",
      supplier: supplier,
      orderId: this.phoneSaleDetail.orderid,
      ticketType: this.$route.query.itemId, //item.id
      ticketId: this.$route.query.ticketId, //id
      opuId: Number(localGet("userid")),
      dialway: 0,
    };
    this.phoneTime = timeFormat(new Date().getTime());
    const { makeDial }: any = await import("@/request/makeDial");
    let res = await makeDial(_arg, this);
    if (res) {
      this.dialid = res.dialid;
    }
  }

  private toCall(value: any) {
    this.supplierOptions.forEach((item: any) => {
      if (item.value == value) {
        let mobile =
          value !== "nxtele"
            ? this.phoneSaleDetail.mobile
            : this.phoneSaleDetail.mobilenxsalt
            ? this.phoneSaleDetail.mobilenxsalt
            : this.phoneSaleDetail.mobile;
        this.call(item.id, mobile);
      }
    });
  }

  private async savePhoneCase(type: any) {
    // 保存案件接口
    let _arg = {
      caseid: this.$route.query.id,
      itemId: this.$route.query.itemId,
      ticketId: this.$route.query.ticketId, // Ticket Id
      phoneConnect: this.selectForm.callStatus, //是否接通
      phoneCallInput: this.phoneSaleDetail.mobile, // 拨打对象手机号
      phoneTime: this.phoneTime, // 拨打时间
      phoneResult: this.selectForm.callResult, // 拨打结果
      desc: this.remark,
      result: this.selectForm.callResult,
      callId: this.dialid, //拨打记录ID
      nextStep: type, //放款 2  继续跟进1
      birthday:
        this.dialogForm.birthday.slice(0, 4) +
        this.dialogForm.birthday.slice(5, 7) +
        this.dialogForm.birthday.slice(8, 10),
    };

    const {
      savePhoneSaleCaseReq,
      savePhoneSaleCaseRequest,
    }: any = await import("@/request/phoneSale");
    let res = await savePhoneSaleCaseRequest.handleHttp(
      savePhoneSaleCaseReq(_arg),
      null
    );
    if (res && res.right) {
      this.$message({
        message: this.$tc("tipsWrh.opreSuccess"),
        type: "success",
      });
      if (type == 2) {
        this.centerDialogVisible = false;
      }
      this.$emit("changeTitle");
    }
  }

  private onCopy(e: any) {
    // e.text
    this.$message.success("copy success");
  }
  private onError(e: any) {
    this.$message.success("copy failed");
  }
}
